'use strict';
import {createEventHandler} from 'recompose';
import {stateGo} from 'redux-ui-router';
import {getOrganization} from '../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {formsListActions} from '../actions/formsListActions';
import {formResponseRequirementExports} from '../redux/formResponseRequirementExports';


FormListController.$inject = [
  '$scope',
  '$ngRedux',
  '$popup',
  '$miscUtils',
  '$contextMenu',
  '$ionicViewSwitcher',
  'FormListFilter',
  'OrganizationDomain',
];

export function FormListController(
  $scope,
  $ngRedux,
  $popup,
  $miscUtils,
  $contextMenu,
  $ionicViewSwitcher,
  FormListFilter,
  OrganizationDomain,
) {
  const vm = $scope.formList = this;
  const filter = FormListFilter(vm, $scope);
  const {
    handler: onClickItem,
    stream: clickItem$,
  } = createEventHandler();

  vm.create = create;
  vm.edit = edit;
  vm.remove = $miscUtils.blockPromise(remove);
  vm.onClickItem = onClickItem;

  $ngRedux.state$
    .map(getOrganization)
    .takeUntil(eventToObservable($scope, SCOPE_DESTROY)) // this is probably overkill
    .filter(organization => !!organization)
    .take(1) // Ensures we only get 1 occurrence
    .subscribe(organization => {
      $scope.$evalAsync(() => {
        // TODO(redux-domain): Convert
        vm.organization = organization;
        filter.initFiltering(OrganizationDomain.$getFormsList(getId(organization)));
      });
    });

  clickItem$
    .throttleTime(300)
    .takeUntil(eventToObservable($scope, SCOPE_DESTROY))
    .subscribe(form => {
      const actions = [
        {messageId: 'forms.context.export.reqs.label', action: exportReqs.bind(null, form)},
        {messageId: 'forms.context.edit.label', action: edit.bind(null, form)},
        {messageId: 'forms.context.delete.label', action: remove.bind(null, form), important: true},
      ];

      return $contextMenu.show({
        titleMessageId: 'default.options.context.title.label',
        titleMessageParams: {name: form.name},
        cancelMessageId: 'defaults.context.cancel.label',
        actions: actions,
      });
    });

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function create() {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.forms-create'));
  }

  function exportReqs(form) {
    $ngRedux.dispatch(formResponseRequirementExports.actions.showModal({
      formTitle: form.title,
      parentId: getId(form),
    }));
  }

  function edit(form) {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.forms-editor', {formId: getId(form)}));
  }

  // TODO(i18n): convert to message codes
  function remove(form) {
    if (!form) {
      return Promise.resolve(null);
    } else {
      const orgId = getId(getOrganization($ngRedux.getState()));
      const label = form.title;
      const action = formsListActions.deleteItem({
        id: getId(form),
        label,
      }, {parentId: orgId});
      return $popup
        .confirm({
          title: 'Delete Form',
          /* eslint-disable-next-line max-len */
          template: `<div style="text-align: center;">Are you sure you want to delete<br/>${label}?<br/>This will delete all uses of this form.</div>`,
        })
        .then(result => result ? $ngRedux.dispatch(action) : void 0);
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

}



// WEBPACK FOOTER //
// ./src/js/forms/controllers/FormListController.js